<template>
    <!-- <div>
    <section>-->
    <v-parallax src="../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png" :height="parallaxHeight">
        <!-- Layout para toda la página: *********************************************************** -->
        <!-- <v-container fill-height fluid class="privacidad"> -->
        <v-container>
            <v-layout align-start justify-center>
                <!-- Flex para la ventana: **************************************************************** -->
                <v-flex xs12 sm10 elevation-6>
                    <div class="sub-window">
                        <v-container pa-2 grid-list-md>
                            <!-- Encabezado con el título de la subventana y el botón para cerrarla: -->
                            <v-layout row>
                                <v-flex xs10 class="text-left">
                                    <div
                                        class="text-left display-1 font-weight-bold brown--text text--darken-4"
                                    >Políticas de Privacidad</div>
                                </v-flex>
                                <v-flex xs2 class="text-right">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn text @click="onClose" v-on="on">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Cerrar</span>
                                    </v-tooltip>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-card class="mx-auto transparent" width="100%" elevation="0">
                                        <v-card-title
                                            class="red--text text--darken-2 subtitle-1"
                                        >IDENTIFICACIÓN Y DOMICILIO DEL RESPONSABLE</v-card-title>

                                        <v-card-text
                                            class="brown--text text--darken-4 text-sm-left"
                                        >
                                            MARAMAHE, S.A. DE C.V., Distribuidora BACCO, S.A. DE C.V., así como a todas las
                                            empresas que pertenezcan a su grupo corporativo, (en adelante denominadas en
                                            conjunto como “CATABOCATA”), con domicilio ubicado en Guillermo González
                                            Camarena No. 2000, local 3, Colonia Lomas de Santa Fe, Álvaro Obregón, C.P. 01210,
                                            Ciudad de México, México, es responsable de recabar sus datos personales para los
                                            efectos enlistados en el presente aviso, así como del uso y la protección de los mismos.
                                        </v-card-text>

                                        <v-card-title
                                            class="red--text text--darken-2 subtitle-1"
                                        >FINALIDADES DEL TRATAMIENTO DE DATOS PERSONALES</v-card-title>

                                        <v-card-text
                                            class="brown--text text--darken-4 text-sm-left"
                                        >
                                            Por lo anterior, de conformidad con lo estipulado en la Ley Federal de Protección de
                                            Datos Personales en Posesión de los Particulares (en adelante “LA LEY”), “CATABOCATA”
                                            le informa que la finalidad del tratamiento de sus datos personales por parte de la
                                            misma, de manera enunciativa más no limitativa será para una de las siguientes
                                            opciones: Enviarle promociones, publicidad, beneficios, descuentos, lanzamientos de
                                            productos o campañas, concursos, cupones de descuentos, invitaciones a participar en
                                            catas, eventos o campañas de “CATABOCATA”, información de iniciativas, eventos,
                                            noticias, actualización de bases de datos internas, para el uso de fines comerciales,
                                            operativos, de servicio, estadísticos, registro de clientes, proveedores y empleados,
                                            encuestas de servicio, emisión de la factura, para realizar auditorías, entre otros.
                                        </v-card-text>

                                        <v-card-title class="red--text text--darken-2 subtitle-1">
                                            MEDIOS Y PROCEDIMIENTOS PARA EL EJERCICIO DE LOS “DERECHOS ARCO” Y PARA
                                            LIMITAR EL USO O DIVULGACIÓN DE LOS DATOS
                                        </v-card-title>

                                        <v-card-text
                                            class="brown--text text--darken-4 text-sm-left"
                                        >
                                            Mediante el presente aviso, “CATABOCATA” le informa que Usted tiene derecho de
                                            acceder, rectificar y cancelar sus datos personales, así como de oponerse al tratamiento
                                            de los mismos o revocar el consentimiento para el fin que nos haya otorgado. Para ello
                                            Usted puede ponerse en contacto con nosotros en las direcciones, teléfonos y/o correos
                                            electrónicos que mencionamos a continuación:
                                        </v-card-text>
                                        <v-card-text
                                            class="brown--text text--darken-4 text-sm-left subtitle-2"
                                        >
                                            Guillermo González Camarena No. 2000, local 3,
                                            <br />Colonia Lomas de Santa Fe, Álvaro Obregón,
                                            <br />C.P. 01210, Ciudad de México, México.
                                            <br />Correo electrónico: santafe@catabocata.com
                                            <br />Teléfonos: + 52 55-5004-7787
                                        </v-card-text>

                                        <v-card-text
                                            class="brown--text text--darken-4 text-sm-left"
                                        >Los horarios de atención son de lunes a viernes de 10:30 a 14:30 horas y de 16:00 a 20:00 horas.</v-card-text>

                                        <v-card-title
                                            class="red--text text--darken-2 subtitle-1"
                                        >TRANSFERENCIAS DE DATOS PERSONALES</v-card-title>

                                        <v-card-text
                                            class="brown--text text--darken-4 text-sm-left"
                                        >
                                            Asimismo, le informamos que sus datos personales pueden ser transferidos y tratados
                                            dentro y fuera del país, por personas distintas a “CATABOCATA”. En ese sentido, su
                                            información puede ser compartida con a terceros que actúen en nombre de
                                            “CATABOCATA” o cualquier empresa de su mismo grupo corporativo ya sean nacionales
                                            o extranjeras, para procesarlos de acuerdo con el/los objetivo(s) para los cuales fueron
                                            originariamente recopilados o procesarse para cualquier otro objetivo autorizado por
                                            “LA LEY”, en el entendido de que estos terceros deberán de obligarse para que dichos
                                            datos personales y datos personales sensibles sean utilizados solamente para el
                                            cumplimiento de los objetivos acordados así como a no vender o revelar su información
                                            personal y/o personal sensible a terceros, excepto en aquellos casos autorizados por “LA
                                            LEY”, con previa autorización de “CATABOCATA”.
                                            <br />
                                            <br />Si Usted no manifiesta su oposición, por medio de un correo electrónico o comunicación
                                            a las direcciones antes mencionadas, para que sus datos personales sean transferidos,
                                            se entenderá que ha otorgado su consentimiento para ello.
                                        </v-card-text>

                                        <v-card-title
                                            class="red--text text--darken-2 subtitle-1"
                                        >PROCEDIMIENTO Y MECANISMO PARA CONOCER CAMBIOS EN EL AVISO DE PRIVACIDAD</v-card-title>

                                        <v-card-text
                                            class="brown--text text--darken-4 text-sm-left"
                                        >
                                            Cualquier modificación a este Aviso de Privacidad “CATABOCATA” la comunicará vía
                                            Internet por lo que podrá consultarla en nuestra página
                                            web: http://www.catabocata.com/privacidad
                                        </v-card-text>

                                        <v-card-title
                                            class="red--text text--darken-2 subtitle-1"
                                        >TRATAMIENTO INDEBIDO DE DATOS PERSONALES</v-card-title>

                                        <v-card-text
                                            class="brown--text text--darken-4 text-sm-left"
                                        >
                                            Si Usted como titular considera que su derecho a la protección de sus datos personales
                                            ha sido lesionado por alguna conducta u omisión de parte de “CATABOCATA”, o
                                            presume alguna violación a las disposiciones previstas en “LA LEY” y demás
                                            ordenamientos aplicables, podrá interponer su inconformidad o denuncia ante el
                                            Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos
                                            Personales (INAI). Para más información le sugerimos visitar su página oficial de
                                            Internet www.inai.org.mx.
                                        </v-card-text>

                                        <v-card-title
                                            class="red--text text--darken-2 subtitle-1"
                                        >CONSENTIMIENTO</v-card-title>

                                        <v-card-text
                                            class="brown--text text--darken-4 text-sm-left"
                                        >
                                            Usted manifiesta que otorga su consentimiento al presente aviso de privacidad, pues ha
                                            leído este y conoce las finalidades para el tratamiento de sus datos personales; las
                                            transferencias que “CATABOCATA” efectúa y que consiente libremente el tratamiento
                                            de sus datos personales en los términos descritos en este aviso de privacidad.
                                        </v-card-text>

                                        <v-card-text
                                            class="brown--text text--darken-4 text-sm-right subtitle-1"
                                        >Fecha de la última actualización: 26 de junio de 2019.</v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-parallax>
    <!-- </section>
    </div>-->
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'privacidad',
    data() {
        return {};
    },
    created() {},
    computed: {
        ...mapGetters(['navMainLogo']),
        mainLogoHeight() {
            var height = '200';
            if (this.$vuetify.breakpoint.xs) {
                height = '250';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '300';
            } else if (this.$vuetify.breakpoint.md) {
                height = '350';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '400';
            } else if (this.$vuetify.breakpoint.xl) {
                height = '450';
            }
            return height;
        },
        parallaxHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '3700';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '2600';
            } else if (this.$vuetify.breakpoint.md) {
                height = '1900';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '1600';
            } else {
                height = '1400';
            }
            return height;
        }
    },
    methods: {
        onClose() {
            this.$router.push('/');
        }
    }
};
</script>

<style scoped>
.privacidad {
    /*background: url('../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png');*/
    background-size: cover;

    background-size: cover;
    width: 100%;
    height: 100%;
}
.sub-window {
    /* background-color: #e0e0e0;
    opacity: 0.3; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.3);
}
.transparent {
    background-color: transparent !important;
    border-color: transparent !important;
}
</style>